import { PathwayTableFilter } from '@core/models/filter-types.model';

export const APPLICATION_CI_PATHWAY_COMPONENTS = {
  ACTIVITY_FUEL_TYPE: 'ActivityFuelTypeComponent',
  PATHWAY_INFORMATION: 'PathwayInformationComponent',
};

export const APPLICATION_NEW_CI_PATHWAY_COMPONENTS = {
  BASIC_INFORMATION: 'BasicInformationComponent',
  FACILITIES_INFORMATION: 'FacilitieOrEquipmentsComponent',
  FEEDSTOCK_INFORMATION: 'FeedstocksInfoComponent',
  UPLOAD_DOCUMENTS_INFORMATION: 'PathwayInformationComponent',
  CONTACT_PERSON_INFORMATION: 'ContactPersonInfoComponent',
};

export const SHOW_NEW_CI_PATHWAY_STEPS_KEY = 'featureVersion';
export const OLD_CI_PATHWAY_STEPS = [
  {
    id: 1,
    name: 'ACTIVITY_FUEL_TYPE',
    completed: false,
    component: APPLICATION_CI_PATHWAY_COMPONENTS.ACTIVITY_FUEL_TYPE,
  },
  {
    id: 2,
    name: 'PATHWAY_INFORMATION',
    completed: false,
    component: APPLICATION_CI_PATHWAY_COMPONENTS.PATHWAY_INFORMATION,
  },
];

export const NEW_CI_PATHWAY_STEPS = [
  {
    id: 1,
    name: 'BASIC_INFORMATION',
    completed: false,
    component: APPLICATION_NEW_CI_PATHWAY_COMPONENTS.BASIC_INFORMATION,
  },
  {
    id: 2,
    name: 'FACILITIES_INFORMATION',
    completed: false,
    component: APPLICATION_NEW_CI_PATHWAY_COMPONENTS.FACILITIES_INFORMATION,
  },
  {
    id: 3,
    name: 'FEEDSTOCK_INFORMATION',
    completed: false,
    component: APPLICATION_NEW_CI_PATHWAY_COMPONENTS.FEEDSTOCK_INFORMATION,
  },
  {
    id: 4,
    name: 'UPLOAD_DOCUMENTS_INFORMATION',
    completed: false,
    component: APPLICATION_NEW_CI_PATHWAY_COMPONENTS.UPLOAD_DOCUMENTS_INFORMATION,
  },
  {
    id: 5,
    name: 'CONTACT_PERSON_INFORMATION',
    completed: false,
    component: APPLICATION_NEW_CI_PATHWAY_COMPONENTS.CONTACT_PERSON_INFORMATION,
  },
];

export const APPLICATION_CI_PATHWAY = {
  page_title: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway.mainStepTitle',

  steps: NEW_CI_PATHWAY_STEPS,

  buttons: {
    showSave: true,
    showSubmit: true,
    submitPrefix: 'submitRegistrationReportButton',
  },
};

export const PATHWAY_TABLE_DETAILS = {
  tableListApiUri: '/cfr-service/application/pathwayApplicationPageSearch',
  tableHeaderType: 'PATHWAY_APPLICATION',
  tableFilter: PathwayTableFilter,
  hasViewTemple: false,
  hasActionTemple: true,
};

// todo change to form-factory format but there's need to change the logic
// export const APPLICATION_CI_PATHWAY_ACTIVITY_FUEL_TYPE = [
//   {
//     groupFields: false,
//     className: 'col-12',
//     fieldGroup: [
//       {
//         type: 'dict-select',
//         className: 'col-6',
//         key: 'fuel',
//         source: SOURCE_DATA_TYPE.FUELS,
//         dataType: 'PRODFF/LIQUID',
//         label: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway.activityDropdown',
//         disabled: false,
//         required: true,
//         id: 'fuelSubjApplication',
//       },
//       {
//         type: 'dict-select',
//         className: 'col-6',
//         key: 'fuel',
//         source: SOURCE_DATA_TYPE.FUELS,
//         dataType: 'PRODFF/LIQUID',
//         label: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway.fuelDropdown',
//         disabled: false,
//         required: true,
//         id: 'fuelSubjApplication',
//       },
//       {
//         key: 'radio3',
//         type: 'radio',
//         className: 'col-12',
//         label: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway.radioOpt1',
//         required: true,
//         inline: true,
//         options: [
//           {value: 'New', key: 'New'},
//           {value: 'Modified', key: 'Modified'},
//         ],
//       },
//     ],
//   },
// ];


export const APPLICATION_CI_PATHWAY_ACTIVITY_FUEL_TYPE = [
  {
    fieldGroupClassName: 'row',
    fieldGroup: [
      {
        className: 'col-6',
        type: 'dict-select',
        wrappers: ['form-field'],
        key: 'activityId',
        templateOptions: {
          label: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway.activityDropdown',
          translatePrefix: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway',
          required: true,
          source: 'getActivities',
          placeholder: 'selectItem',
          change: (field, $event) => {
            // this.creditRemittanceData = {
            //   ...field.model,
            //   certificateNumber: $event ? $event.certificateNumber : '',
            // };
            // if ($event) {
            //   this.unitService.getObligation($event.id).subscribe(data => {
            //     this.obligations = data;
            //   });
            // }
          },
        },
      },
      {
        className: 'col-6',
        type: 'dict-select',
        wrappers: ['form-field'],
        key: 'fuelId',
        templateOptions: {
          label: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway.fuelDropdown',
          translatePrefix: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway',
          required: true,
          source: 'getActivities',
          placeholder: 'selectItem',
          change: (field, $event) => {
            // this.creditRemittanceData = {
            //   ...field.model,
            //   certificateNumber: $event ? $event.certificateNumber : '',
            // };
            // if ($event) {
            //   this.unitService.getObligation($event.id).subscribe(data => {
            //     this.obligations = data;
            //   });
            // }
          },
        },
      },
      {
        type: 'radio',
        key: 'submissionType',
        className: 'col-6 inline',
        templateOptions: {
          required: true,
          options: [
            { value: 'New', key: 'New' },
            { value: 'Modified', key: 'Modified' },
          ],
          label: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway.radioOpt1',
          translatePrefix: 'SUBMISSION_MANAGEMENT_MODULE.applicationCIPathway',
        },
      },
    ],
  },
];
